export const DEEP_LINK = {
  ANALYTICS: '/manage/analytics',
  CHANGE_PLAN: '/manage/subscription/change',
  REACTIVATE_SUB: '/manage/subscription/reactivate'
}

export default DEEP_LINK